import React from 'react';
import { CircularProgress, Box } from '@mui/material';

const Loader = () => (
  <Box
    sx={{
      position: 'fixed',
      top: 0, left: 0, width: '100%', height: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.6)',
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      zIndex: 1300,
    }}
  >
    <CircularProgress size={60} thickness={4} sx={{ color: '#d30038' }} />
  </Box>
);

export default Loader;
